import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiUser, FiGift, FiLifeBuoy, FiHome } from 'react-icons/fi';
import { FaWallet } from 'react-icons/fa';
import { MdOutlineHistory } from 'react-icons/md';

const BottonMenu = ({ w3_close }) => {
  return (
    <div className="main_bottom_menus">
      <nav className="bottom_navbar_new">
        <NavLink
          exact
          to="/landing"
          className="center_create_btn"
          activeClassName="center_active"
          onClick={w3_close}
        >
          <div className="plus_circle">
            <img style={{width:'25px'}} src="/home.png"  onClick={w3_close} alt="" />
          </div>
        </NavLink>
        

        <NavLink
          exact
          to="/wallet"
          className="nav_item_new"
          activeClassName="active_nav"
          onClick={w3_close}
        >
          <div className="nav_icon_box">
            <img style={{width:'25px'}} src="/images/icons/wallett.png"  onClick={w3_close} alt="" />
          </div>
        </NavLink>

        

        <NavLink
          exact
          to="/support"
          className="nav_item_new"
          activeClassName="active_nav"
          onClick={w3_close}
        >
          <div className="nav_icon_box">
             <img style={{width:'25px'}} src="/images/icons/customer-support.png"  onClick={w3_close} alt="" />

          </div>
        </NavLink>

        <NavLink
          exact
          to="/refer"
          className="nav_item_new"
          activeClassName="active_nav"
          onClick={w3_close}
        >
          <div className="nav_icon_box">
            <img style={{width:'25px'}} src="/images/icons/bootom-refer.png"  onClick={w3_close} alt="" />
          </div>
        </NavLink>
        <NavLink
          exact
          to="/Profile"
          className="nav_item_new"
          activeClassName="active_nav"
          onClick={w3_close}
        >
          <div className="nav_icon_box">
            <img style={{width:'25px'}} src="/images/icons/bootom_user.png"  onClick={w3_close} alt="" />
          </div>
        </NavLink>
      </nav>
    </div>
  );
};

export default BottonMenu;
